"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReservationState = void 0;
var ReservationState;
(function (ReservationState) {
    ReservationState["pending"] = "pending";
    ReservationState["accepted"] = "accepted";
    ReservationState["canceled"] = "canceled";
    ReservationState["rejected"] = "rejected";
    ReservationState["error"] = "error";
})(ReservationState || (exports.ReservationState = ReservationState = {}));
//# sourceMappingURL=ReservationState.js.map